"use strict";

exports.__esModule = true;
exports.reportPermissions = exports.getLicenceWithCustomUrls = exports.USER_PERMISSION_REPORTS = exports.REPORT_UTILIZATION = exports.REPORT_TOP_TOOLS = exports.REPORT_TOOL_PERFORMANCE = exports.REPORT_PRODUCTION_EXECUTION = exports.REPORT_PERFORMANCE_GRID = exports.REPORT_PART_METRICS = exports.REPORT_OPERATOR_METRICS = exports.REPORT_LIFE_METERING = exports.REPORT_ICT_SUMMARY = exports.REPORT_HOURLY_UTILIZATION = exports.REPORT_HOURLY_ACTIVITY_SUMMARY = exports.REPORT_DOWNTIME = exports.REPORT_DEVICE_DETAILS = exports.REPORT_DEVICE_DATA = exports.REPORT_DAILY_SUMMARY = exports.REPORT_CONDITIONS_DETAILS = exports.REPORT_CONDITIONS = exports.REPORT_COMMENTS = exports.REPORT_ALERTS = exports.REPORT_ACTIVITY_SUMMARY = exports.REPORT_ACTIVITY_DETAILS = exports.PERMISSIONS = exports.MAX_AGE_IN_DAYS_WITH_BASIC_LICENSE = exports.MAX_AGE_IN_DAYS_WITH_ADVANCED_LICENSE = exports.ENRICH_LICENSE_LEVELS = exports.DEFAULT_LICENCE_LEVELS = exports.DEFAULT_LICENCES = exports.ACCESS_RIGHT_UTILIZE_ANALYTICS = exports.ACCESS_RIGHT_TOOL_PERFORMANCE = exports.ACCESS_RIGHT_TOOLING_ANALYTICS = exports.ACCESS_RIGHT_TICKETING = exports.ACCESS_RIGHT_REPORT_VIEW = exports.ACCESS_RIGHT_REPORT_EDIT = exports.ACCESS_RIGHT_PLANT_TWIN = exports.ACCESS_RIGHT_PERFORMANCE_GRID = exports.ACCESS_RIGHT_PART_METRICS = exports.ACCESS_RIGHT_OPERATOR_VIEW = exports.ACCESS_RIGHT_OPERATOR_METRICS = exports.ACCESS_RIGHT_OPERATOR_EDIT = exports.ACCESS_RIGHT_MEDIA = exports.ACCESS_RIGHT_MAINTENANCE_MANAGER = exports.ACCESS_RIGHT_MAINTAIN_ANALYTICS = exports.ACCESS_RIGHT_KNOWLEDGE_BASE = exports.ACCESS_RIGHT_HOURLY_ACTIVITY_SUMMARY = exports.ACCESS_RIGHT_HISTORICAL_PART_COUNT = exports.ACCESS_RIGHT_ENTERPRISE_DASHBOARD = exports.ACCESS_RIGHT_ENRICH_UI = exports.ACCESS_RIGHT_ENRICH = exports.ACCESS_RIGHT_DOCS = exports.ACCESS_RIGHT_DEVICE_DATA_BASIC = exports.ACCESS_RIGHT_DEVICE_DATA_ADVANCED = exports.ACCESS_RIGHT_DECISION_TREE = exports.ACCESS_RIGHT_DATA_ON_DEMAND = exports.ACCESS_RIGHT_DASHBOARD_VIEW = exports.ACCESS_RIGHT_DASHBOARD_EDIT = exports.ACCESS_RIGHT_CONDITIONS = exports.ACCESS_RIGHT_ALERTS = exports.ACCESS_RIGHT_AI_CHAT = exports.ACCESS_RIGHT_ADMIN = exports.ACCESS_RIGHT_ACTIVITY_SUMMARY = void 0;
var _reportPermissions;
var ACCESS_RIGHT_ADMIN = exports.ACCESS_RIGHT_ADMIN = "admin";
var ACCESS_RIGHT_ALERTS = exports.ACCESS_RIGHT_ALERTS = "alerts";
var ACCESS_RIGHT_DASHBOARD_VIEW = exports.ACCESS_RIGHT_DASHBOARD_VIEW = "dashboard_view";
var ACCESS_RIGHT_DASHBOARD_EDIT = exports.ACCESS_RIGHT_DASHBOARD_EDIT = "dashboard_edit";
var ACCESS_RIGHT_REPORT_VIEW = exports.ACCESS_RIGHT_REPORT_VIEW = "report_view";
var ACCESS_RIGHT_REPORT_EDIT = exports.ACCESS_RIGHT_REPORT_EDIT = "report_edit";
var ACCESS_RIGHT_OPERATOR_VIEW = exports.ACCESS_RIGHT_OPERATOR_VIEW = "operator_view";
var ACCESS_RIGHT_OPERATOR_EDIT = exports.ACCESS_RIGHT_OPERATOR_EDIT = "operator_edit";
var ACCESS_RIGHT_TICKETING = exports.ACCESS_RIGHT_TICKETING = "ticketing";
var ACCESS_RIGHT_TOOLING_ANALYTICS = exports.ACCESS_RIGHT_TOOLING_ANALYTICS = "tooling_analytics";
var ACCESS_RIGHT_UTILIZE_ANALYTICS = exports.ACCESS_RIGHT_UTILIZE_ANALYTICS = "utilize_analytics";
var ACCESS_RIGHT_HOURLY_ACTIVITY_SUMMARY = exports.ACCESS_RIGHT_HOURLY_ACTIVITY_SUMMARY = "hourly_activity_summary";
var ACCESS_RIGHT_MAINTAIN_ANALYTICS = exports.ACCESS_RIGHT_MAINTAIN_ANALYTICS = "maintain_analytics";
var ACCESS_RIGHT_DOCS = exports.ACCESS_RIGHT_DOCS = "docs";
var ACCESS_RIGHT_DECISION_TREE = exports.ACCESS_RIGHT_DECISION_TREE = "decision_tree";
var ACCESS_RIGHT_ENRICH = exports.ACCESS_RIGHT_ENRICH = "enrich";
var ACCESS_RIGHT_PLANT_TWIN = exports.ACCESS_RIGHT_PLANT_TWIN = "plant_twin";
var ACCESS_RIGHT_DEVICE_DATA_BASIC = exports.ACCESS_RIGHT_DEVICE_DATA_BASIC = "device_data_basic";
var ACCESS_RIGHT_DEVICE_DATA_ADVANCED = exports.ACCESS_RIGHT_DEVICE_DATA_ADVANCED = "device_data_advanced";
var ACCESS_RIGHT_KNOWLEDGE_BASE = exports.ACCESS_RIGHT_KNOWLEDGE_BASE = "knowledge_base";
var ACCESS_RIGHT_MEDIA = exports.ACCESS_RIGHT_MEDIA = "media";
var ACCESS_RIGHT_DATA_ON_DEMAND = exports.ACCESS_RIGHT_DATA_ON_DEMAND = "data_on_demand";
var ACCESS_RIGHT_MAINTENANCE_MANAGER = exports.ACCESS_RIGHT_MAINTENANCE_MANAGER = "maintenance_manager";
var ACCESS_RIGHT_ENRICH_UI = exports.ACCESS_RIGHT_ENRICH_UI = "enrich_ui";
var ACCESS_RIGHT_ENTERPRISE_DASHBOARD = exports.ACCESS_RIGHT_ENTERPRISE_DASHBOARD = "enterprise_dashboard";
var ACCESS_RIGHT_HISTORICAL_PART_COUNT = exports.ACCESS_RIGHT_HISTORICAL_PART_COUNT = "part_count_edit";
var ACCESS_RIGHT_AI_CHAT = exports.ACCESS_RIGHT_AI_CHAT = "ai_chat";
var MAX_AGE_IN_DAYS_WITH_BASIC_LICENSE = exports.MAX_AGE_IN_DAYS_WITH_BASIC_LICENSE = 90;
var MAX_AGE_IN_DAYS_WITH_ADVANCED_LICENSE = exports.MAX_AGE_IN_DAYS_WITH_ADVANCED_LICENSE = 365 * 5;
var DEFAULT_LICENCE_LEVELS = exports.DEFAULT_LICENCE_LEVELS = [ACCESS_RIGHT_ADMIN, ACCESS_RIGHT_ALERTS, ACCESS_RIGHT_DASHBOARD_EDIT, ACCESS_RIGHT_DASHBOARD_VIEW, ACCESS_RIGHT_OPERATOR_EDIT, ACCESS_RIGHT_OPERATOR_VIEW, ACCESS_RIGHT_TICKETING, ACCESS_RIGHT_UTILIZE_ANALYTICS, ACCESS_RIGHT_DOCS, ACCESS_RIGHT_ENTERPRISE_DASHBOARD];
var ENRICH_LICENSE_LEVELS = exports.ENRICH_LICENSE_LEVELS = DEFAULT_LICENCE_LEVELS.concat(ACCESS_RIGHT_ENRICH, ACCESS_RIGHT_REPORT_VIEW, ACCESS_RIGHT_REPORT_EDIT);
var getLicenceWithCustomUrls = exports.getLicenceWithCustomUrls = function getLicenceWithCustomUrls(documentationUrl, customerSupportUrl) {
  return {
    plantName: "test",
    partnerName: "test",
    branding: {
      themeName: "vimana"
    },
    accessRights: ENRICH_LICENSE_LEVELS,
    documentationUrl: documentationUrl,
    customerSupportUrl: customerSupportUrl
  };
};
var DEFAULT_LICENCES = exports.DEFAULT_LICENCES = {
  demoLicence: {
    plantName: "demo",
    partnerName: "",
    branding: {
      themeName: "vimana"
    },
    accessRights: ENRICH_LICENSE_LEVELS
  },
  enrich2Licence: {
    plantName: "demo",
    partnerName: "",
    branding: {
      themeName: "vimana"
    },
    accessRights: ENRICH_LICENSE_LEVELS.concat([ACCESS_RIGHT_ENRICH_UI])
  },
  testLicence: {
    plantName: "test",
    partnerName: "test",
    branding: {
      themeName: "vimana"
    },
    accessRights: ENRICH_LICENSE_LEVELS
  },
  baseLicence: {
    plantName: "",
    partnerName: "",
    branding: {
      themeName: "base"
    },
    accessRights: DEFAULT_LICENCE_LEVELS
  }
};
var REPORT_DOWNTIME = exports.REPORT_DOWNTIME = "downtime";
var REPORT_ACTIVITY_SUMMARY = exports.REPORT_ACTIVITY_SUMMARY = "activitySummary";
var REPORT_HOURLY_ACTIVITY_SUMMARY = exports.REPORT_HOURLY_ACTIVITY_SUMMARY = "hourlyActivitySummary";
var REPORT_PERFORMANCE_GRID = exports.REPORT_PERFORMANCE_GRID = "performanceGrid";
var REPORT_HOURLY_UTILIZATION = exports.REPORT_HOURLY_UTILIZATION = "hourlyUtilization";
var REPORT_OPERATOR_METRICS = exports.REPORT_OPERATOR_METRICS = "operatorMetrics";
var REPORT_TOOL_PERFORMANCE = exports.REPORT_TOOL_PERFORMANCE = "toolPerformance";
var REPORT_UTILIZATION = exports.REPORT_UTILIZATION = "utilization";
var REPORT_DEVICE_DETAILS = exports.REPORT_DEVICE_DETAILS = "deviceDetails";
var REPORT_DAILY_SUMMARY = exports.REPORT_DAILY_SUMMARY = "dailySummary";
var REPORT_ALERTS = exports.REPORT_ALERTS = "alerts";
var REPORT_CONDITIONS = exports.REPORT_CONDITIONS = "conditions";
var REPORT_DEVICE_DATA = exports.REPORT_DEVICE_DATA = "deviceData";
var REPORT_PRODUCTION_EXECUTION = exports.REPORT_PRODUCTION_EXECUTION = "productionExecutionSummary";
var REPORT_ICT_SUMMARY = exports.REPORT_ICT_SUMMARY = "ictSummary";
var REPORT_TOP_TOOLS = exports.REPORT_TOP_TOOLS = "topTools";
var REPORT_PART_METRICS = exports.REPORT_PART_METRICS = "partMetrics";
var REPORT_LIFE_METERING = exports.REPORT_LIFE_METERING = "lifeMetering";
var ACCESS_RIGHT_TOOL_PERFORMANCE = exports.ACCESS_RIGHT_TOOL_PERFORMANCE = "tool_performance";
var ACCESS_RIGHT_CONDITIONS = exports.ACCESS_RIGHT_CONDITIONS = ACCESS_RIGHT_REPORT_VIEW;
var REPORT_COMMENTS = exports.REPORT_COMMENTS = "comments";
var ACCESS_RIGHT_PART_METRICS = exports.ACCESS_RIGHT_PART_METRICS = "part_metrics";
var ACCESS_RIGHT_ACTIVITY_SUMMARY = exports.ACCESS_RIGHT_ACTIVITY_SUMMARY = "activity_summary";
var ACCESS_RIGHT_PERFORMANCE_GRID = exports.ACCESS_RIGHT_PERFORMANCE_GRID = "performance_grid";
var ACCESS_RIGHT_OPERATOR_METRICS = exports.ACCESS_RIGHT_OPERATOR_METRICS = "operator_metrics";
var REPORT_ACTIVITY_DETAILS = exports.REPORT_ACTIVITY_DETAILS = "activityDetails";
var REPORT_CONDITIONS_DETAILS = exports.REPORT_CONDITIONS_DETAILS = "conditionsDetails";
var reportPermissions = exports.reportPermissions = (_reportPermissions = {}, _reportPermissions[REPORT_DOWNTIME] = [ACCESS_RIGHT_UTILIZE_ANALYTICS], _reportPermissions[REPORT_ACTIVITY_SUMMARY] = [ACCESS_RIGHT_ACTIVITY_SUMMARY], _reportPermissions[REPORT_HOURLY_ACTIVITY_SUMMARY] = [ACCESS_RIGHT_HOURLY_ACTIVITY_SUMMARY], _reportPermissions[REPORT_PERFORMANCE_GRID] = [ACCESS_RIGHT_PERFORMANCE_GRID], _reportPermissions[REPORT_TOOL_PERFORMANCE] = [ACCESS_RIGHT_TOOL_PERFORMANCE], _reportPermissions[REPORT_HOURLY_UTILIZATION] = [ACCESS_RIGHT_UTILIZE_ANALYTICS], _reportPermissions[REPORT_OPERATOR_METRICS] = [ACCESS_RIGHT_OPERATOR_METRICS], _reportPermissions[REPORT_UTILIZATION] = [ACCESS_RIGHT_UTILIZE_ANALYTICS], _reportPermissions[REPORT_DAILY_SUMMARY] = [ACCESS_RIGHT_UTILIZE_ANALYTICS], _reportPermissions[REPORT_ALERTS] = [ACCESS_RIGHT_UTILIZE_ANALYTICS], _reportPermissions[REPORT_CONDITIONS] = [ACCESS_RIGHT_CONDITIONS], _reportPermissions[REPORT_COMMENTS] = [ACCESS_RIGHT_UTILIZE_ANALYTICS], _reportPermissions[REPORT_DEVICE_DATA] = [ACCESS_RIGHT_UTILIZE_ANALYTICS], _reportPermissions[REPORT_PRODUCTION_EXECUTION] = [ACCESS_RIGHT_TOOLING_ANALYTICS], _reportPermissions[REPORT_TOP_TOOLS] = [ACCESS_RIGHT_TOOLING_ANALYTICS], _reportPermissions[REPORT_PART_METRICS] = [ACCESS_RIGHT_PART_METRICS], _reportPermissions[REPORT_LIFE_METERING] = [ACCESS_RIGHT_MAINTAIN_ANALYTICS], _reportPermissions[REPORT_DEVICE_DETAILS] = [ACCESS_RIGHT_UTILIZE_ANALYTICS], _reportPermissions[REPORT_ICT_SUMMARY] = [ACCESS_RIGHT_TOOLING_ANALYTICS], _reportPermissions[REPORT_ACTIVITY_DETAILS] = [ACCESS_RIGHT_ACTIVITY_SUMMARY], _reportPermissions[REPORT_CONDITIONS_DETAILS] = [ACCESS_RIGHT_ENRICH], _reportPermissions);
var USER_PERMISSION_REPORTS = exports.USER_PERMISSION_REPORTS = "reports:read";
var PERMISSIONS = exports.PERMISSIONS = {
  VIEW_ALERT: {
    accessRights: [ACCESS_RIGHT_ALERTS],
    permissions: ["alert:use"]
  },
  CREATE_ALERT: {
    accessRights: [ACCESS_RIGHT_ALERTS],
    permissions: ["alert:admin"]
  },
  VIEW_TICKETING: {
    accessRights: [ACCESS_RIGHT_TICKETING],
    permissions: ["ticketing:use"]
  },
  CONFIGURE_TICKETING: {
    permissions: ["ticketing:admin"]
  },
  VIEW_MAXIMO: {
    accessRights: [ACCESS_RIGHT_TICKETING],
    permissions: ["ticketing:link"]
  },
  VIEW_DASHBOARDS: {
    accessRights: [ACCESS_RIGHT_DASHBOARD_VIEW],
    permissions: ["dashboards:view"]
  },
  EDIT_DASHBOARDS: {
    accessRights: [ACCESS_RIGHT_DASHBOARD_EDIT],
    permissions: ["dashboards:edit"]
  },
  CREATE_DASHBOARDS: {
    accessRights: [ACCESS_RIGHT_DASHBOARD_EDIT],
    permissions: ["dashboards:edit"]
  },
  VIEW_REPORTS: {
    accessRights: [ACCESS_RIGHT_REPORT_VIEW],
    permissions: ["reports:view"]
  },
  EDIT_REPORTS: {
    accessRights: [ACCESS_RIGHT_REPORT_EDIT],
    permissions: ["reports:edit"]
  },
  CREATE_REPORTS: {
    accessRights: [ACCESS_RIGHT_REPORT_EDIT],
    permissions: ["reports:edit"]
  },
  VIEW_OPERATOR_PANELS: {
    accessRights: [ACCESS_RIGHT_OPERATOR_VIEW],
    permissions: ["operators:view"]
  },
  EDIT_OPERATOR_PANELS: {
    accessRights: [ACCESS_RIGHT_OPERATOR_EDIT],
    permissions: ["operators:edit"]
  },
  CREATE_OPERATOR_PANELS: {
    accessRights: [ACCESS_RIGHT_OPERATOR_EDIT],
    permissions: ["operators:edit"]
  },
  VIEW_ACTIVITY_SUMMARY: {
    accessRights: reportPermissions[REPORT_ACTIVITY_SUMMARY],
    permissions: [USER_PERMISSION_REPORTS]
  },
  VIEW_HOURLY_ACTIVITY_SUMMARY: {
    accessRights: reportPermissions[REPORT_HOURLY_ACTIVITY_SUMMARY],
    permissions: [USER_PERMISSION_REPORTS]
  },
  VIEW_PERFORMANCE_GRID_REPORT: {
    accessRights: reportPermissions[REPORT_PERFORMANCE_GRID],
    permissions: [USER_PERMISSION_REPORTS]
  },
  VIEW_PART_METRICS: {
    accessRights: reportPermissions[REPORT_PART_METRICS],
    permissions: [USER_PERMISSION_REPORTS]
  },
  VIEW_OPERATOR_METRICS: {
    accessRights: reportPermissions[REPORT_OPERATOR_METRICS],
    permissions: [USER_PERMISSION_REPORTS]
  },
  VIEW_TOOL_PERFORMANCE: {
    accessRights: reportPermissions[REPORT_TOOL_PERFORMANCE],
    permissions: [USER_PERMISSION_REPORTS]
  },
  VIEW_CONDITIONS: {
    accessRights: reportPermissions[REPORT_CONDITIONS],
    permissions: [USER_PERMISSION_REPORTS]
  },
  VIEW_CALENDAR: {
    accessRights: [ACCESS_RIGHT_ADMIN],
    permissions: ["calendar:view"]
  },
  EDIT_CALENDAR: {
    accessRights: [ACCESS_RIGHT_ADMIN],
    permissions: ["calendar:edit"]
  },
  PLANT_TWIN: {
    accessRights: [ACCESS_RIGHT_PLANT_TWIN]
  },
  PLANT_SETTINGS: {
    permissions: ["plant_settings:update", "plant_settings:read"]
  },
  VIEW_DOCUMENTATION: {
    accessRights: [ACCESS_RIGHT_DOCS]
  },
  VIEW_DECISION_TREE: {
    accessRights: [ACCESS_RIGHT_DECISION_TREE],
    permissions: ["decisiontree:view"]
  },
  EDIT_DECISION_TREE: {
    accessRights: [ACCESS_RIGHT_DECISION_TREE],
    permissions: ["decisiontree:edit"]
  },
  CREATE_DECISION_TREE: {
    accessRights: [ACCESS_RIGHT_DECISION_TREE],
    permissions: ["decisiontree:create"]
  },
  DOWNLOAD_DEVICE_DATA_BASIC: {
    accessRights: [ACCESS_RIGHT_DEVICE_DATA_BASIC]
  },
  DOWNLOAD_DEVICE_DATA_ADVANCED: {
    accessRights: [ACCESS_RIGHT_DEVICE_DATA_ADVANCED]
  },
  VIEW_RULE_CONFIGURATION: {
    accessRights: [ACCESS_RIGHT_ADMIN]
  },
  VIEW_KNOWLEDGE_BASE: {
    accessRights: [ACCESS_RIGHT_KNOWLEDGE_BASE],
    permissions: ["knowledgebase:view"]
  },
  EDIT_KNOWLEDGE_BASE: {
    accessRights: [ACCESS_RIGHT_KNOWLEDGE_BASE],
    permissions: ["knowledgebase:edit"]
  },
  CREATE_KNOWLEDGE_BASE: {
    accessRights: [ACCESS_RIGHT_KNOWLEDGE_BASE],
    permissions: ["knowledgebase:create"]
  },
  VIEW_TARGETS: {
    permissions: ["target:read"]
  },
  VIEW_AUDIT_LOG: {
    permissions: ["audit-log:read"]
  },
  VIEW_MEDIA: {
    accessRights: [ACCESS_RIGHT_MEDIA],
    permissions: ["media:view"]
  },
  EDIT_MEDIA: {
    accessRights: [ACCESS_RIGHT_MEDIA],
    permissions: ["media:edit"]
  },
  CREATE_MEDIA: {
    accessRights: [ACCESS_RIGHT_MEDIA],
    permissions: ["media:create"]
  },
  VIEW_DATA_ON_DEMAND: {
    accessRights: [ACCESS_RIGHT_DATA_ON_DEMAND],
    permissions: ["jobs:read"]
  },
  CREATE_DATA_ON_DEMAND: {
    accessRights: [ACCESS_RIGHT_DATA_ON_DEMAND],
    permissions: ["jobs:create"]
  },
  VIEW_MAINTENANCE_MANAGER: {
    accessRights: [ACCESS_RIGHT_MAINTENANCE_MANAGER]
  },
  EDIT_MAINTENANCE_MANAGER: {
    accessRights: [ACCESS_RIGHT_MAINTENANCE_MANAGER],
    permissions: ["maintain:plan:*"]
  },
  VIEW_RULE_CONFIGURATION_UI: {
    accessRights: [ACCESS_RIGHT_ENRICH_UI],
    permissions: ["enrich_ui:read"]
  },
  EDIT_MESSAGES: {
    permissions: ["messages:write"]
  },
  VIEW_HISTORICAL_PART_COUNT: {
    accessRights: [ACCESS_RIGHT_HISTORICAL_PART_COUNT],
    permissions: ["part_count:read"]
  },
  EDIT_HISTORICAL_PART_COUNT: {
    accessRights: [ACCESS_RIGHT_HISTORICAL_PART_COUNT],
    permissions: ["part_count:write"]
  },
  AI_CHAT: {
    accessRights: [ACCESS_RIGHT_AI_CHAT]
  }
};